import { Component, inject } from '@angular/core';
import { faBoxArchive, faDashboard, faQuestion, faSquarePollVertical, faUserGroup, faUsers, faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';
import { NgxPermissionsModule } from 'ngx-permissions';
import { QuotaService } from '../../../utilization/services/quota.service';

@Component({
    selector: 'app-side-menu',
    imports: [RouterModule, FontAwesomeModule, NgxPermissionsModule],
    templateUrl: './side-menu.component.html',
    styleUrl: './side-menu.component.scss'
})
export class SideMenuComponent {
  quotaSrv = inject(QuotaService);

  // Icons
  faDashboard = faDashboard;
  faUsers = faUsers;
  faUserGroup = faUserGroup;
  faBoxArchive = faBoxArchive;
  faSquarePollVertical = faSquarePollVertical;
  faWarning = faWarning;
  faQuestion = faQuestion;
}
